export default __webpack_public_path__ + "static/media/details-2.f35cbd11.png";